import React from "react";
import { useLang } from "../lib/LangContext";
import { Instagram, Youtube, Twitter, Mail, MapPin, Phone } from "lucide-react";
import AdtreeLogo from "./AdtreeLogo";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="relative bg-black border-t border-white/10">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <a href="#top" className="inline-flex items-center mb-6">
              <AdtreeLogo size="lg" testId="footer-logo" />
            </a>
            <p className="text-white/60 max-w-sm leading-relaxed">{t.footer.tagline}</p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] uppercase tracking-[0.3em] text-brand-yellow mb-4">
              {t.footer.explore}
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><a href="#about" className="hover:text-brand-yellow transition-colors">{t.nav.about}</a></li>
              <li><a href="#services" className="hover:text-brand-yellow transition-colors">{t.nav.services}</a></li>
              <li><a href="#benefits" className="hover:text-brand-yellow transition-colors">{t.nav.creators}</a></li>
              <li><a href="#testimonials" className="hover:text-brand-yellow transition-colors">{t.nav.testimonial}</a></li>
              <li><a href="#register" className="hover:text-brand-yellow transition-colors">{t.nav.join}</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-[11px] uppercase tracking-[0.3em] text-brand-yellow mb-4">
              {t.footer.contact}
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-brand-yellow" />
                mcn@adtree.co.id
              </li>
              <li className="flex items-center gap-3">
                <a
                  href="https://wa.me/6285220708569"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="flex items-center gap-3 hover:text-brand-yellow transition-colors"
                >
                  <Phone size={16} className="text-brand-yellow" />
                  +62 852‑2070‑8569 (WhatsApp)
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-brand-yellow mt-0.5" />
                Jakarta
              </li>
            </ul>
            <h4 className="text-[11px] uppercase tracking-[0.3em] text-brand-yellow mt-8 mb-4">
              {t.footer.follow}
            </h4>
            <div className="flex gap-3">
              {[Instagram, Youtube, Twitter].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-10 h-10 border border-white/20 flex items-center justify-center text-white/70 hover:bg-brand-yellow hover:text-black hover:border-brand-yellow transition-colors"
                  aria-label="social"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Mega wordmark */}
        <div className="relative overflow-hidden mb-10">
          <div className="font-anton uppercase text-[22vw] md:text-[18vw] leading-[0.85] tracking-tight text-transparent select-none" style={{ WebkitTextStroke: "1px rgba(255,214,10,0.35)" }}>
            adtree<span className="text-brand-yellow" style={{ WebkitTextStroke: "0" }}>GO</span>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-6 border-t border-white/10 text-xs uppercase tracking-[0.2em] text-white/40">
          <div>© 2026 Adtree Digital Indonesia. {t.footer.rights}</div>
          <div>Made in Indonesia · For creators worldwide</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
